export function correctNotInterestedType(type) {
  const types = {
    CA: 'Contract Award',
    FGO: 'Federal Grant Opportunity',
    FCO: 'Federal Contract Opportunity',
    NSN: 'NSN Opportunity',
    SLCO: 'State Local Opportunity',
    SLCF: 'State Local Forecast',
    SLCA: 'State Local Award',
  };

  return types[type] || type;
}
